import { useCallback, useEffect, useState } from "react";
import { useAppContext, useService } from "../../../../hooks";
import { brandInfo } from "../../../../constant";

export const useDetailingServices = () => {
  const {
    actions: { setServices },
    selectors: { getServices },
  } = useAppContext();
  const { getServices: fetchServices } = useService("Service");
  const [activeMedia, setactiveMedia] = useState(null);
  const [activeService, setactiveService] = useState(null);

  const { openModal, closeModal } = useService("Misc");
  const getServicesData = useCallback(async () => {
    const result = await fetchServices();
    if (result.status) {
      if (result.data?.length !== 0) {
        setServices(result.data);
      }
    }
  }, [fetchServices, setServices]);

  const viewServiceVideo = useCallback(
    (item) => {
      setactiveService(item);
      openModal("media-modal");
      setactiveMedia(item.featuredVideo ?? brandInfo.defaultVideo);
    },
    [openModal]
  );

  useEffect(() => {
    if (getServices().length === 0) {
      getServicesData();
    }
  }, [getServices, getServicesData]);

  return {
    serviceList: getServices(),
    viewServiceVideo,
    activeMedia,
    closeModal,
    activeService,
  };
};
